import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {SIDEBAR2_BUTTONS} from "../../constants";
import {clearAllMenusEvents} from "../canvas/core/workspace/workspaceEvents";
import config from "../canvas/store/sqftConfig";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../actions/sqftMenuFunctions";
import WithSqftFooterCancel from "../../hocs/withSqftFooterCancel";
import WithAddToQuote from "../../hocs/withAddToQuote";

const SqftNavAside2 = (props) => {
  const {activeButton, menuOpened, setSQFTActiveButton, setSQFTMenuOpened} = props

  const handleButtonClick = (button) => {
    clearAllMenusEvents();
    setSQFTActiveButton(button.menu);
    config.workspace.menuItemActive = button.menu;
    if (button.hasMenu) {
      const newMenu = menuOpened === button.menu
        ? "" // same button click
        : button.menu;
      setSQFTMenuOpened(newMenu);
    }
  };

  return (
    <aside className="sidebar2">
      <div className="sidebar2--top">
        {SIDEBAR2_BUTTONS.map((item, index) => (
          <button key={index} className={"button " + item.classNames + (activeButton === item.menu ? " button--active" : "")}
                  onClick={() => handleButtonClick(item)}
                  data-menu={item.menu}
                  title={item.title}>
              <span className="button-text">
                <FormattedMessage id={"sqft.navigation.menu." + item.text}/>
              </span>
            <span className={item.additionalClassNames }/>
          </button>
        ))}
      </div>
      <div className="sidebar2--bottom">
        <WithSqftFooterCancel props={props}>
          {(handleCloseSQFtCalc) => (
            <button className="button button--cancel button--blue"
                    id="mobile_cancel"
                    onClick={() => handleCloseSQFtCalc()}>
              <span className="button-text" data-text="sqft.navigation.menu.mobile.cancel">Cancel</span>
            </button>
          )}
        </WithSqftFooterCancel>
        <WithAddToQuote props={props}>
          {(handleAddToQuoteClick) => (
            <button className="button button--add-to-quote button--green"
                    id="mobile_add_to_quote"
                    onClick={() => handleAddToQuoteClick()}>
              <span className="button-text" data-text="sqft.navigation.menu.mobile.addToQuote">Add to Quote</span>
            </button>
          )}
        </WithAddToQuote>
      </div>
    </aside>
  )
}

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
    activeButton: store.sqftMenuState.activeButton,
  };
};

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSQFTMenuOpened,
}


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavAside2);
